import {isPlatformBrowser} from '@angular/common';
import {Component, EventEmitter, Inject, Input, Output, PLATFORM_ID} from '@angular/core';
import {CustomSize} from 'src/app/cart/interface/custom-size';
import {CartCalculationService} from 'src/app/cart/service/cart-calculation.service';
import {CustomSizeProfile} from 'src/app/product-details/interface/custom-size-profile';
import {Product} from 'src/app/product-details/interface/product';
import {ProductSizeProfileList} from 'src/app/product-details/interface/product-size-profile-list';
import {SizeProfile} from 'src/app/product-details/interface/size-profile';
import {SizeProfileOptionItem} from 'src/app/product-details/interface/size-profile-option-item';
import {PrepareInstockCalculationService} from 'src/app/product-details/service/prepare-instock-calculation.service';
import {PriceCalculationService} from 'src/app/product-details/service/price-calculation.service';
import {QuantityCalculationService} from 'src/app/product-details/service/quantity-calculation.service';
import {GlobalService} from 'src/app/services/global.service';

@Component({
	selector: 'fb-choose-size',
	templateUrl: './choose-size.component.html',
	styleUrls: ['./choose-size.component.scss']
})
export class ChooseSizeComponent {
	constructor(
		private _quantiCalculation: QuantityCalculationService,
		private _priceCalculation: PriceCalculationService,
		private _globalService: GlobalService,
		private _cartCalculation: CartCalculationService,
		private _prepareItemInstockCalculation: PrepareInstockCalculationService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	};

	@Input() sizeData: SizeProfile = {} as SizeProfile;
	@Input() customSizeData: CustomSizeProfile = {} as CustomSizeProfile;
	@Input() customSizeDataEnabled: boolean = false;
	@Input() productSizeProfileList: ProductSizeProfileList[] = [];
	@Input() product: Product = {} as Product;

	@Output() passQuantity = new EventEmitter<number>();

	public isBrowser: boolean = false;
	public deltaIndex: number = 0;
	public copyDeltaIndex: number = 0;
	public keyfeature = '';
	public openSizeGuide = false;
	public openCustomSIzeModal = false;
	public sizeOption: SizeProfileOptionItem[] = this.sizeData.sizeProfileOptionList;
	public isFabricProduct: boolean = false;

	public selectedCustomSizeData: CustomSize = {} as CustomSize;
	public selectedCustomSizeLabel: string = '';

	public openSizeguide(): void {
		this.openSizeGuide = true;
		this._globalService.popUpOpenClose(true);
	}


	public close(): void {
		this.openSizeGuide = false;
		this._globalService.popUpOpenClose(false);
	}


	public openCustomSize(): void {
		this.openCustomSIzeModal = true;
		this.deltaIndex = -1;
		this._globalService.popUpOpenClose(true);
	}


	public closeCustomSize(): void {
		this.openCustomSIzeModal = false;
		this.deltaIndex = this.copyDeltaIndex;
		this._globalService.popUpOpenClose(false);

	}

	public continueCustomSize(): void {

		let madeToOrderConsumedFabric = this.product.madeToOrderProfile?.consumedFabric||1;

		this.openCustomSIzeModal = false;
		this._prepareItemInstockCalculation.isSelectedSizeInStock = false;
		this._prepareItemInstockCalculation.BySizeProfileConsumedFabric = 1;

		// this._priceCalculation.selectedConsumedFabric = 1;
		// this._cartCalculation.selectedConsumedFabric = 1;

		this._priceCalculation.selectedConsumedFabric = madeToOrderConsumedFabric;
		this._cartCalculation.selectedConsumedFabric = madeToOrderConsumedFabric;

		this._priceCalculation.selectedCustomSize = this.customSizeData;

		setTimeout(() => this._priceCalculation.calculatePrice(false, false, 'choose-size'), 0)

		this._globalService.popUpOpenClose(false);

		this.selectedCustomSizeData = this._cartCalculation.customSize;

		// console.log(this.selectedCustomSizeData);

		this.selectedCustomSizeLabel = this._prepareCustomSizeLabel(this.selectedCustomSizeData);

		// debugger
		this._prepareItemInstockCalculation.returnResultInsockQuantity$.next(true);

		if(this.selectedCustomSizeLabel) {

			this.deltaIndex = -1;

		}
		else this.deltaIndex = 0;

		// this._globalService.isTheOrderInstock.next(false);
	}


	public selectSize(i: number, obj: SizeProfileOptionItem): void {
		this._cartCalculation.customSize = {} as CustomSize;
		this._priceCalculation.selectedCustomSize =  {} as CustomSizeProfile;

		this.selectedCustomSizeLabel ='';

		this._cartCalculation.selectedSize = obj;
		this.deltaIndex = i;
		this.copyDeltaIndex = i
		// console.log(obj);
		this.keyfeature = obj.keyFeature;


		if (i == 0) {
			this._cartCalculation.orderType = 'IN_STOCK';
			this.passQuantity.emit(0);
		}
		else this._cartCalculation.orderType = 'MADE_TO_ORDER';

		this._selectSizeBasedOnSizeProfileList(obj);

		setTimeout(() => this._quantiCalculation.updateQuantity(), 0)

		// price calculation

		this._priceCalculation.selectedConsumedFabric = obj.consumedFabric
		this._cartCalculation.selectedConsumedFabric = obj.consumedFabric
		setTimeout(() => this._priceCalculation.calculatePrice(false, false, 'choose-size'), 0)

	}

	private _selectSizeBasedOnSizeProfileList( obj: SizeProfileOptionItem): void {
		// debugger
		// if (obj.quantity) { //not undefined

		if(this.productSizeProfileList.length > 0){

			for(let i = 0; i < this.productSizeProfileList.length; i++) {
				//new qty calculation

				let avlSize: ProductSizeProfileList =  this.productSizeProfileList[i];

				// if(avlSize.disabled && this.product.productGroup !== 'fabric')
				// 	break;

				//if default qty 0
				if (obj.label === avlSize.sizeProfileOption.label &&
					!this.product.totalQuantity &&
					this.product.productGroup==='fabric' ) {


					this._cartCalculation.orderType = 'MADE_TO_ORDER';
					this._prepareItemInstockCalculation.isSelectedSizeInStock = false;
					this._globalService.isTheOrderInstock.next(false);
					break
				}

				if (obj.label == avlSize.sizeProfileOption.label &&
					this.product.productGroup==='fabric' ) {

					this._cartCalculation.orderType = 'IN_STOCK';

					this._prepareItemInstockCalculation.isSelectedSizeInStock = true;
					this._prepareItemInstockCalculation.BySizeProfileConsumedFabric = obj.consumedFabric;
					this._prepareItemInstockCalculation.sizeQTY = avlSize.quantity;

					this._globalService.isTheOrderInstock.next(true);
					break
				}

				if (obj.label == avlSize.sizeProfileOption.label &&
					 avlSize.quantity) {
					this._cartCalculation.orderType = 'IN_STOCK';

					this._prepareItemInstockCalculation.isSelectedSizeInStock = true;
					this._prepareItemInstockCalculation.BySizeProfileConsumedFabric = obj.consumedFabric;
					this._prepareItemInstockCalculation.sizeQTY = avlSize.quantity;

					this._globalService.isTheOrderInstock.next(true);

					if( !this._priceCalculation.isSelectedFabricInStock ) {
						this._cartCalculation.orderType = 'MADE_TO_ORDER';
						this._prepareItemInstockCalculation.isSelectedSizeInStock = false;
						this._globalService.isTheOrderInstock.next(false);
					}

					if( !this._priceCalculation.isSelectedFabricInStock &&
						this.product.productGroup==='finished' ) {
						this._cartCalculation.orderType = 'IN_STOCK';
						this._prepareItemInstockCalculation.isSelectedSizeInStock = true;
						this._globalService.isTheOrderInstock.next(true);
					}

					break
				}
				else{
					this._cartCalculation.orderType = 'MADE_TO_ORDER';

					this._prepareItemInstockCalculation.isSelectedSizeInStock = false;
					this._prepareItemInstockCalculation.BySizeProfileConsumedFabric = obj.consumedFabric;
					this._globalService.isTheOrderInstock.next(false);
				}

				if( !this._prepareItemInstockCalculation.isSelectedFabricInStock &&
					 this._prepareItemInstockCalculation.isSelectedSizeInStock ) {

						this._cartCalculation.orderType = 'MADE_TO_ORDER';

						this._prepareItemInstockCalculation.isSelectedSizeInStock = true;
						this._prepareItemInstockCalculation.BySizeProfileConsumedFabric = obj.consumedFabric;
						this._globalService.isTheOrderInstock.next(false);
				}


			}

			if( !this._prepareItemInstockCalculation.isSelectedFabricInStock &&
				this._prepareItemInstockCalculation.isSelectedSizeInStock ) {

				   this._cartCalculation.orderType = 'MADE_TO_ORDER';

				   this._prepareItemInstockCalculation.isSelectedSizeInStock = true;
				   this._prepareItemInstockCalculation.BySizeProfileConsumedFabric = obj.consumedFabric;
				   this._globalService.isTheOrderInstock.next(false);
		   }


			// });
		}
		else {

			this._globalService.isAnySizeAvailable = false;

			this._cartCalculation.orderType = 'MADE_TO_ORDER';
			this._globalService.isTheOrderInstock.next(false);

			this._prepareItemInstockCalculation.isSelectedSizeInStock = false;
			this._prepareItemInstockCalculation.BySizeProfileConsumedFabric = obj.consumedFabric;
		}

		this._prepareItemInstockCalculation.returnResultInsockQuantity$.next(true)
	}


	public ngOnInit(): void {

		this._priceCalculation.isSizeProfileAvailable = true;
		if (this.isBrowser) {
			if (window.location.href.includes('product/fabric-product/')) {
				this.isFabricProduct = true;
			}
		}


		this.sizeOption = this.sizeData.sizeProfileOptionList;
		this.keyfeature = this.sizeOption[0].keyFeature;
		let availableSize: ProductSizeProfileList[] = this.productSizeProfileList;
		// console.log(this.sizeData);
		// console.log(this.sizeOption);
		// console.log(availableSize);
		this._cartCalculation.orderType = 'IN_STOCK';


		// debugger
		// setTimeout(() => this._quantiCalculation.updateQuantity(), 0)

		// price calculation

		this._priceCalculation.selectedConsumedFabric = this.sizeOption[0].consumedFabric
		this._cartCalculation.selectedConsumedFabric = this.sizeOption[0].consumedFabric
		setTimeout(() => {
			console.log(this.product.madeToOrderFabric?.id, this.product.id, 'size')
			if( !this._priceCalculation.makingCharges && (this.product.madeToOrderFabric?.id !== this.product.id)){
				this._priceCalculation.calculatePrice(false, true, 'choose-size');
			}
			else{
				this._priceCalculation.calculatePrice(false, false, 'choose-size');
			}

		},0);

		setTimeout(() => this._selectSizeBasedOnSizeProfileList( this.sizeOption[0]), 500); //check if defautl size is available / instock

	}

	private _prepareCustomSizeLabel(customSizeData: CustomSize): string {

		let listOfLabel: string[] = [];
		let label: string = '';

		for (const [key, value] of Object.entries(customSizeData)) {
			// console.log(key, value);
			listOfLabel.push(`${key}: ${value}`);
		}

		  label = listOfLabel.join();

		return label
	}

}
